/**
 * Local wall-clock "now" as a `<input type="datetime-local">` value
 * (YYYY-MM-DDTHH:mm), used as the earliest selectable preferred viewing time.
 *
 * Shared by both inquiry forms. Built by shifting the instant by the local
 * offset before formatting in UTC, because a datetime-local input has no
 * timezone: `toISOString()` alone would set the floor to UTC-now, which is in
 * the past for anyone west of UTC and in the future for anyone east -- and in
 * the east that silently rejects the next few hours.
 *
 * @param now - Overridable for tests.
 */
export const getNowLocalDateTime = (now: Date = new Date()) => {
    const local = new Date(now);
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toISOString().slice(0, 16);
};
